export const CASE_STUDIES = [
  {
    slug: "arsenalwebstats",
    label: "CASE STUDY // RUST PLUGIN",
    name: "ArsenalWebStats",
    displayName: "ARSENAL WEBSTATS",
    game: "Rust",
    client: "Arsenal Servers Network",
    category: "Competitive Statistics",
    version: "1.8.0",
    status: "LIVE IN PRODUCTION",
    projectUrl: "/plugins",
    ctaLabel: "See It In The Foundry",
    hero:
      "How we gave a five-server Rust network a memory: every kill, raid and wipe tracked, structured and streamed to a central competitive platform.",
    problem: {
      title: "The problem",
      intro:
        "Rust wipes erase everything. On a network built for competition, that meant every achievement vanished on a schedule.",
      points: [
        "Vanilla Rust tracks nothing. No K/D, no leaderboards, no raid records — a community that wanted competition had no scoreboard to compete on.",
        "Wipe cycles destroyed history. A dominant wipe meant nothing a week later, and seasons spanning multiple wipes were impossible to measure.",
        "The data that did exist was trapped. Plugin data lived in JSON files on game servers — useless to a website, a Discord bot or a profile page.",
        "Five servers were five islands. A player had a different identity and a different record on every server in the network.",
      ],
    },
    build: {
      title: "The build",
      intro:
        "A dedicated statistics bridge plugin, an event taxonomy designed for competition, and one canonical identity across the network.",
      points: [
        "ArsenalWebStats streams structured player and server data from every Rust server to the central Arsenal backend — the website consumes the API, never raw plugin files.",
        "A competition-grade event taxonomy: combat (kills, deaths, K/D, headshots, accuracy, kill distance, streaks), farming, raiding, world events, economy, activity and clan contribution.",
        "Raiding defined properly: a timed explosive destroying a tool cupboard counts as a raid — edge cases designed, not stumbled into.",
        "Time-aware aggregation from day one: current wipe, previous wipe, current season, historical seasons and career stats — history is never overwritten when a server wipes.",
        "One identity everywhere: Steam ID as the canonical identifier, linked to Discord through ArsenalAuth, surfaced in-game through the ArsenalMenu CUI and on the web — never five copies of the same player.",
      ],
    },
    results: {
      title: "The result",
      intro:
        "v1.8.0 runs in production across the live network — the foundation of the Arsenal competitive platform.",
      points: [
        "Every wipe, every season and every career is now recorded — three-month Arsenal Seasons aggregate multiple wipes across participating servers.",
        "Leaderboards, profiles and head-to-head comparison exist because the data layer was built for them first, not bolted on after.",
        "Players see their own statistics without leaving the game through the in-game profile interface — the same identity and numbers the website shows.",
        "The taxonomy was deliberately over-built: new stat categories slot in without redesigning the profile or the database, which is exactly what a growing competitive platform needs.",
      ],
    },
    testimonial: null,
    nextSteps:
      "Public player profiles, live clan stat tiles, network-wide competitive comparisons and career pages — the scoring layer is ready for them.",
  },
];
